import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {create as createRecord} from "app/requests/admin/cases";
import {withoutBlankValues} from "lib/ext/object";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import Form from "./form";

export default function AdminCasesNew() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const [block, setBlock] = useState(false);
  const [record, setRecord] = useState({
    active: true,
    case_tags: [],
    name: "",
    number: "",
    questions: []
  });
  const onChange = ({target}) => {
    setBlock(true);
    setRecord({...record, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    const {case_tags: caseTags, questions, ...recordChanges} = withoutBlankValues(record);
    if(caseTags) { recordChanges.case_tags_attributes = caseTags; }
    if(questions) { recordChanges.questions_attributes = questions; }

    setBlock(false);
    createRecord({case: recordChanges}).then(({message, success}) => {
      if(success) {
        navigate("/admin/cases", {message, type: "success"});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [record]});

  usePrompt({when: block});

  return (
    <div>
      <h1 className="text-center">New Case</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
